import './index.css';
import appStoreBadge from '../../assets/images/black.svg';
import googlePlayBadge from '../../assets/images/google-play-badge.png';
import ipad from '../../assets/images/ipadpro13.png';
import iphone from '../../assets/images/iphone12black.png';

const Index = () => {
  return (
    <div className='bartender'>
      <div className='bartender__links'>
        <p className='bartender__subTitle'>
          Our bartender App <div className='bartender__line-through' />
        </p>
        <h1 className='bartender__title'>
        Venue App
        </h1>
        <p className='bartender__desc'>
          Incoming orders are easily sorted from Pending to Preparing to Ready. 
          Depending on your order configuration, real-time push notifications inform
          users when their order is ready, in the oven or on the road to them.
          Order verification can be done using the QR camera scanner or unique order number. 
        </p>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className='bartender__links-images'>
            <a
              href='https://apps.apple.com/gb/app/drinking-venues/id1554283520'
              target='_blank'
              rel='noreferrer'
            >
              <img src={appStoreBadge} style={{ height: 55 }} alt='App Store' />
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=com.drinking.venues'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={googlePlayBadge}
                style={{ height: 80, width: 205 }}
                alt='Google Play Store'
              />
            </a>
          </div>
        </div>
      </div>
      <div
      className="bartender__devices"
    
      >
        <img src={iphone} className='bartender__iphone' alt='iPhone' />
        <img src={ipad} className='bartender__samsung' alt='Samsung' />
      </div>
    </div>
  );
};

export default Index;
